module.exports = __webpack_public_path__ + "static/media/VelocityIcon.9c8624d3.svg";